// extracted by mini-css-extract-plugin
export default {"container":"stepHeader_container__GYMXN","titleStyles":"stepHeader_titleStyles__QHDw8","arrowStyles":"stepHeader_arrowStyles__B1tiD","dotStyles":"stepHeader_dotStyles__xPIDz"};